import { Source } from "core-lib/constants/sourceSKU";
import { PaymentApp } from "../constants/PaymentApp";
import { PaymentInstrument } from "../constants/PaymentInstrument";
import { PaymentPartner } from "../constants/PaymentPartner";
import { EligibilityType } from "../services/checkEligibility";
import { BankType } from "./Bank";
import { Order } from "./Order";
import { BreakupData, SummaryData } from "./Summary";
import { WalletBalanceData } from "./WalletBalance";
import { ItemDetail, MetaInfo, OrderDetails, PaymentModeTypes } from "./types";
export type Amount = null | number;

export type CardType = {
  token?: string | null;
  savedCardId?: number | null;
  name?: string;
  nickname?: string;
  number: string;
  cvv?: number | string;
  cvvTitle: string;
  save?: number;
  type?: string | null;
  iin?: number | null;
  network?: string | null;
  expiryMonth?: number | string;
  expiryYear?: number | string;
  owner?: string;
  icon?: string;
  isCvvLess?: boolean;
  paymentPartner?: PaymentPartner | null;
  paymentApp?: PaymentApp | null;
  cp?: any;
};

export enum ValidationSource {
  PromoPopUp = "PromoPopUp",
  PromoMethodPopup = "PromoMethodPopup",
}

export type Wallet = {
  enabled: boolean;
  isApplied: boolean;
};
export type Addon = {
  key: string;
  value: string | number;
};

export type Tip = {
  sku: string;
  amount: number;
};

export type Promo = {
  enabled: boolean;
  autoApply: boolean;
};

export type ValidatedPromo = {
  code: string | null;
  walletAccepted: boolean;
  eligibleMethods: MethodGroupData[];
  acceptsCard: boolean;
  validBins?: string[];
};

export type AppliedPromo = {
  code: string | null;
  description: string | null;
  discount: number | null;
  discountBreakup: null | { [key: string]: number };
  msg: null | string;
  isCashback: boolean;
  cashbackMsg: null | string;
  showPromoCodeSavings?: boolean;
  walletErrMsg?: null | string;
  walletAccepted: boolean;
  rawData: any;
  uiMeta: {
    title: string;
    subtitle: string;
    staticText: string;
    ctaText: string;
  };
};

export interface redirectionObjType {
  success?: string;
  pending?: string;
  failed?: string;
}

export type Origin = {
  source: Source;
  data: any;
  redirectionObj?: redirectionObjType;
};

export enum PaymentUiType {
  Add = "add",
  Select = "select",
  AutoPayBanner = "autopay_banner",
}

export type MethodData = {
  eligibilityApiUrl?: string | null;
  eligibilityResponse?: EligibilityType;
  displayName: string;
  description: string;
  paymentPartner: PaymentPartner;
  paymentInstrument: PaymentInstrument;
  paymentApp: PaymentApp;
  paymentByNative: number | null;
  icon: string;
  id: string | number;
  bankCode: null | string;
  cardInfo: null | CardType;
  rawData?: any;
  availability?: {
    status: boolean;
    msg: string;
  };
  uiType?: string;
  isRetry?: string;
};

export type MethodGroupData = {
  title: string;
  logo?: string;
  list?: MethodData[];
};

export type AutoPay = {
  isAvailable?: boolean;
  isSelected?: boolean;
  methodData?: MethodGroupData[];
};

export type OrderListingParent = {
  page: number;
  hasMore: boolean;
  apiStatus: string;
  data: any[];
};

export type PromoErrorPopupType = {
  title: string;
  subTitle: string;
  cta: {
    title: string;
    webUrl: string;
  };
};

export type ReducerType = {
  amount?: Amount;
  breakup?: BreakupData[];
  wallet?: Wallet;
  addOns?: Addon[];
  promo?: Promo;
  showPromoPopup?: boolean;
  showPromoSuccess?: boolean;
  wasLastPromoSuccessful?: boolean;
  isPromoValidating?: boolean;
  validatedPromo?: null | ValidatedPromo;
  appliedPromo?: null | AppliedPromo;
  origin?: Origin;
  selectedMethod?: MethodData | null;
  methodList?: MethodGroupData[];
  bankList?: BankType[];
  isPaymentReady?: boolean;
  lastUsed?: MethodData | null;
  invalidPromoMsg?: string | null;
  promoErrorPopup?: PromoErrorPopupType;
  orderData?: null | Order;
  walletBalance?: WalletBalanceData;
  showMethodPopup?: boolean;
  showMethodChangeTooltip?: boolean;
  showExistingCardPopup?: boolean;
  summary?: SummaryData;
  autoPay?: AutoPay;
  itemDetails?: any[];
  tip?: Tip;
  orderListing?: OrderListingParent;
  userCardData?: CardType | null;
};

export type CardValidationType = {
  isEligible: boolean;
  isDown: boolean;
  eligibleErrMessage: string;
  downErrMessage: string;
  network: string;
  type: string;
  icon?: string;
  iin: number;
  cvvTitle: string;
};

export type DetailProps = {
  paymentMethods?: PaymentModeTypes[];
  orderDetails: OrderDetails;
  fulfilmentDetails?: { [key: string]: any };
  itemDetails: ItemDetail[];
  isSourceOMS: boolean;
  isOrderConfirmation?: boolean;
  cstUrl: string;
  onDataLoad: () => void;
  metaInfo?: MetaInfo;
};
